import {DateTime} from 'luxon';

const getDateOnly = (dateString) => {
  if (!dateString || typeof dateString !== 'string') return '';
  return dateString.split('T')[0];
};

const isValidYmd = (ymd) => /^\d{4}-\d{2}-\d{2}$/.test(ymd);

export const convertToUtcIsoDayBoundary = (
  date,
  isStartDate,
  isEndDate,
  options = {}
) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';

  const zone = options?.timeZone || 'local';
  let dt = DateTime.fromJSDate(date, {zone});
  if (isStartDate) {
    dt = dt.startOf('day');
  }
  if (isEndDate) {
    dt = dt.endOf('day').set({millisecond: 0});
  }
  return dt.toUTC().toISO() || '';
};

export const toUtcIsoForSingleDay = (ymd, options = {}) => {
  const zone = options?.timeZone || 'local';
  const dateOnly = getDateOnly(ymd);
  if (!isValidYmd(dateOnly)) return '';

  const dt = DateTime.fromISO(dateOnly, {zone}).startOf('day');
  return dt.toUTC().toISO() || '';
};

export const toUtcIsoRangeForDateRange = ({from, to} = {}, options = {}) => {
  const zone = options?.timeZone || 'local';

  const fromOnly = getDateOnly(from);
  const toOnly = getDateOnly(to);

  const formattedFrom = isValidYmd(fromOnly)
    ? DateTime.fromISO(fromOnly, {zone}).startOf('day').toUTC().toISO() || ''
    : '';
  // "to" date: end of day with millisecond always 999 (includes draft records stored with fractional seconds)
  const formattedTo = isValidYmd(toOnly)
    ? DateTime.fromISO(toOnly, {zone})
        .endOf('day')
        .set({millisecond: 999})
        .toUTC()
        .toISO() || ''
    : '';

  if (!formattedFrom && !formattedTo) return '';
  return `${formattedFrom},${formattedTo}`;
};
